import { render, staticRenderFns } from "./ConversionPrivilege.vue?vue&type=template&id=494f2c08&lang=html"
import script from "./ConversionPrivilege.vue?vue&type=script&lang=js"
export * from "./ConversionPrivilege.vue?vue&type=script&lang=js"
import style0 from "./ConversionPrivilege.vue?vue&type=style&index=0&id=494f2c08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports